<script setup lang="ts">
import Choices from "choices.js";
import Chart from 'chart.js/auto';
import MinMaxSlider from '@/components/atomics/MinMaxSliderPercorso.vue';
import {Model} from "@/app/Model";
import {Comms, type IEsito, type ISintesiParams} from "@/app/Comms";
import {RouterLink} from "vue-router";
import {onMounted, ref} from 'vue';
import * as bootstrap from 'bootstrap';
import type {KeyValoreStrNum} from "@/app/data/DataTypes";
import PaginazionePercorso from "@/components/atomics/PaginazionePercorsoPenale.vue";
import PaginazionePercorsoJump from "@/components/atomics/PaginazionePercorsoPenaleJump.vue";
import {PdfGenerator} from "@/app/PdfGenerator";

declare let frontendConfig: any;
declare let gtagO: Function;

//const initialTimeout: number = 1000;
let model: Model = Model.getReactiveInstance();
let chart1: Chart | null = null;
let chart2: Chart | null = null;
let chart3: Chart | null = null;
const CHART_COLORS = {
  gfl1: 'rgb(33, 150, 243)',
  gfl2: 'rgb(22, 91, 170)',
  gfl3: 'rgb(79, 195, 247)',
  gfl4: 'rgb(19, 51, 113)',
  gfl5: 'rgb(227, 242, 253)',
  gfl6: 'rgb(41, 98, 255)',
  gfl7: 'rgb(161, 85, 185)',
  gfl8: 'rgb(22, 191, 214)'
};

onMounted(() => {
  checkStart();
});
function checkStart(): void {
  if (!Model.pen_setupped) {
    setTimeout(() => checkStart(), 100)
  } else if (!Comms.listAllDone) {
      Comms.getInstance().listAll(() => {
        checkStart();
      });
  } else {
    initComponents();
  }
}

//CHOICES
let choices: Choices | null = null;
function initChoices(): void {
  if (choices) choices.destroy();
  let choiceItems: any[] = [{
    value: "",
    label: "Tutti...",
    selected: true,
    disabled: false
  }];
  model.lista_capo_imputazione_legge.forEach(x => choiceItems.push(
      {
        value: x.capo_imputazione_legge,
        label: x.capo_imputazione_legge + ((x.rubrica && x.rubrica != "" && x.rubrica !== x.capo_imputazione_legge)? " | "+ x.rubrica:"") + (x.tot? " <small>["+x.tot+"]</small>":""),
        selected: false,
        disabled: false
      }
  ));
  let itemItems: any[] = [{
    value: "",
    label: "Tutti...",
    selected: true,
    disabled: false
  }]
  //@ts-ignore
  choices = new Choices(document.getElementById('input_capo_imputazione_legge'), {
    items: itemItems,
    choices: choiceItems,
    allowHTML: true,
    placeholder: false,
    loadingText: 'Caricamento...',
    noResultsText: 'Nessun risultato',
    noChoicesText: 'Nessun elemento da selezionare',
    itemSelectText: 'Premi per selezionare',
    shouldSort: false
  });
}

//COMPONENTS
function initComponents(): void {
    initChoices();

  //LO DEVE FARE?
  //chiama i dati attuali
  callQuery();
  //ALTRIMENTI
  //updateComponents();
}
window.addEventListener(
    "listAllRefresh",
    (event) => {
      updateComponents();
      //if (choices && model.pen_flow_percorso.capo_imputazione_legge != "") choices.setChoiceByValue(model.pen_flow_percorso.capo_imputazione_legge);
    }
);
window.addEventListener(
    "resetRefresh",
    (event) => {
      changePercorsoAt('all');
    }
);
function updateComponents(): void {
  //TOOLTIPS
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

  //console.log("Update components", model.pen_flow_percorso, model.pen_get_percorso)
  initChoices();
  if (choices) choices.setChoiceByValue(model.pen_flow_percorso.capo_imputazione_legge);

  //CHARTS 1 2 3
  if (Chart.getChart("canvas_assoluzione")) {
    Chart.getChart("canvas_assoluzione")?.destroy();
  }

  if (model.pen_get_percorso.esito_del_processo.length > 0) {
    const config1 = {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: [{
          label: 'Esito del giudizio',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };
    model.pen_get_percorso.esito_del_processo.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      config1.data.labels.push(Model.lista_esito_del_processo_labels[Model.lista_esito_del_processo.indexOf(x.assoluzione as string)] + " ("+x.percentuale+"%)");
      //@ts-ignore
      config1.data.datasets[0].data.push(x.percentuale);
    });

    //@ts-ignore
    chart1 = new Chart(document.getElementById('canvas_assoluzione'), config1);
  }

  if (Chart.getChart("canvas_distribuzione_motivi_assoluzione")) {
    Chart.getChart("canvas_distribuzione_motivi_assoluzione")?.destroy();
  }

  if (model.pen_get_percorso.distribuzione_motivi_assoluzione && model.pen_get_percorso.distribuzione_motivi_assoluzione.length > 0) {
    const config2 = {
      type: 'pie',
      data: {
        labels: [],
        datasets: [{
          label: 'Distribuzione motivi assoluzione',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };
    model.pen_get_percorso.distribuzione_motivi_assoluzione.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      config2.data.labels.push(x.assoluzione_motivo + " ("+x.percentuale+"%)");
      //@ts-ignore
      config2.data.datasets[0].data.push(x.percentuale);
    });
    //@ts-ignore
    chart2 = new Chart(document.getElementById('canvas_distribuzione_motivi_assoluzione'), config2);
  }

  if (Chart.getChart("canvas_distribuzione_delle_sanzioni")) {
    Chart.getChart("canvas_distribuzione_delle_sanzioni")?.destroy();
  }

  if (model.pen_get_percorso.distribuzione_delle_sanzioni && model.pen_get_percorso.distribuzione_delle_sanzioni.length > 0) {
    const config3 = {
      type: 'pie',
      data: {
        labels: [],
        datasets: [{
          label: 'Distribuzione delle sanzioni',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };
    model.pen_get_percorso.distribuzione_delle_sanzioni.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      config3.data.labels.push(x.pena_principale + " ("+x.percentuale+"%)");
      //@ts-ignore
      config3.data.datasets[0].data.push(x.percentuale);
    });
    //@ts-ignore
    chart3 = new Chart(document.getElementById('canvas_distribuzione_delle_sanzioni'), config3);
  }
  updateMinMaxSliders(true);
  updatePaginazione();
}

//QUERY
function callQueryPaginazione(): void {
  callQuery(true);
}
function callQuery(soloPaginazione: boolean = false): void {
  //chiama i dati attuali
  Comms.getInstance().queryPercorso((e: IEsito) => {
    updateComponents();
  }, soloPaginazione);
}

//FLOW
function changePercorsoAt(field: string): void {
  let valueField = "";
  let stringField = "";
  
  //pulire i successivi in model.pen_flow_percorso
  if (field == "all") {
    model.pen_flow_percorso.capo_imputazione_legge = "";
    if (choices) choices.setChoiceByValue(model.pen_flow_percorso.capo_imputazione_legge);
    field = "capo_imputazione_legge"
  }

  stringField = field;

  switch (field) {
    case "capo_imputazione_legge":
      model.pen_flow_percorso.importo_evaso_active = false;
      model.pen_flow_percorso.importo_evaso_da = Model.lista_importi_minMax[0];
      model.pen_flow_percorso.importo_evaso_a = Model.lista_importi_minMax[1];
      model.pen_flow_percorso.assoluzione = "";
      model.pen_flow_percorso.assoluzione_motivo = "";
      model.pen_flow_percorso.pena_principale = "";

      valueField = model.pen_flow_percorso.capo_imputazione_legge;
      stringField = "capo imputazione";

      if (valueField) {
        let inputCapoImputazioneLegge: HTMLElement | null = document.getElementById("input_capo_imputazione_legge");
        let optionCapoImputazioneLegge: HTMLElement | null = null;

        if (inputCapoImputazioneLegge) {
          optionCapoImputazioneLegge = inputCapoImputazioneLegge.querySelector("option");

          if (optionCapoImputazioneLegge) {
            valueField = optionCapoImputazioneLegge.innerHTML;
            valueField = valueField.replace(/&lt;small&gt;/g, "").replace(/&lt;\/small&gt;/g, "");
          }
        }
      }
      
      break;
    case "importo_evaso":
      model.pen_flow_percorso.assoluzione = "";
      model.pen_flow_percorso.assoluzione_motivo = "";
      model.pen_flow_percorso.pena_principale = "";

      valueField = model.pen_flow_percorso.importo_evaso_da + " - " + model.pen_flow_percorso.importo_evaso_a;
      stringField = "importo evaso";

      break;
    case "assoluzione":
      model.pen_flow_percorso.assoluzione_motivo = "";
      model.pen_flow_percorso.pena_principale = "";

      valueField = model.pen_flow_percorso.assoluzione;
      stringField = "esito del giudizio";

      if (valueField) {
        let inputAssoluzione: HTMLElement | null = document.getElementById("input_assoluzione");
        let optionAssoluzione = null;

        if (inputAssoluzione) {
          optionAssoluzione = inputAssoluzione.querySelectorAll("option");

          if (optionAssoluzione) {
            for (let i = 0; i < optionAssoluzione.length; i++) {
              if (optionAssoluzione[i].selected == true) {
                valueField = optionAssoluzione[i].innerHTML;
              }
            }
          }
        }
      }

      break;
    case "assoluzione_motivo":
      valueField = model.pen_flow_percorso.assoluzione_motivo;
      stringField = "motivo assoluzione";

      break;
    case "pena_principale":
      valueField = model.pen_flow_percorso.pena_principale;
      stringField = "pena principale";

      break;
  }

  if (valueField) {
    gtagO({
      event: 'filtro',
      filtro: stringField,
      valore: valueField,
      percorso: 'Penale'
    })
  }

  //chiama i dati attuali
  callQuery();
}
function canShowCanvas(field: string): string {
  let stylo: string = "row blocco";
  switch (field) {
    case "esito_del_processo":
      if (!model.pen_get_percorso.esito_del_processo || model.pen_get_percorso.esito_del_processo.length < 1) stylo += " not-visible";
      break;
    case "distribuzione_motivi_assoluzione":
      if (!model.pen_get_percorso.distribuzione_motivi_assoluzione || model.pen_get_percorso.distribuzione_motivi_assoluzione.length < 1 || model.pen_flow_percorso.assoluzione == "" || model.pen_flow_percorso.capo_imputazione_legge == "" || (model.pen_flow_percorso.assoluzione != Model.lista_esito_del_processo[2] && model.pen_flow_percorso.assoluzione != Model.lista_esito_del_processo[0])) stylo += " not-visible";
      break;
    case "distribuzione_delle_sanzioni":
      if (!model.pen_get_percorso.distribuzione_delle_sanzioni || model.pen_get_percorso.distribuzione_delle_sanzioni.length < 1 || model.pen_flow_percorso.assoluzione == "" || model.pen_flow_percorso.capo_imputazione_legge == "" || (model.pen_flow_percorso.assoluzione != Model.lista_esito_del_processo[1] && model.pen_flow_percorso.assoluzione != Model.lista_esito_del_processo[0])) stylo += " not-visible";
      break;
  }
  return stylo
}
function canShowField(field: string): string {
  let canShow: string = "row blocco";
  switch (field) {
    case "capo_imputazione_legge":
      break;
    case "importo_evaso":
      if (model.pen_flow_percorso.capo_imputazione_legge == "" || !model.pen_get_percorso.importo_evaso|| !model.pen_get_percorso.importo_evaso.valore || model.pen_get_percorso.importo_evaso.valore == 0) {
        canShow += " not-visible";
        //model.pen_flow_percorso.importo_evaso_active = false;
      } else {
        //model.pen_flow_percorso.importo_evaso_active = true;
      }
      break;
    case "assoluzione":
      if (model.pen_flow_percorso.capo_imputazione_legge == "") {
        canShow += " not-visible";
      }
      break;
    case "assoluzione_motivo":
      if (model.pen_flow_percorso.capo_imputazione_legge == "" || model.pen_flow_percorso.assoluzione == "" || (model.pen_flow_percorso.assoluzione != Model.lista_esito_del_processo[2] && model.pen_flow_percorso.assoluzione != Model.lista_esito_del_processo[0])
     || model.pen_get_percorso.distribuzione_motivi_assoluzione.length< 1) {
        canShow += " not-visible";
      }
      break;
    case "pena_principale":
      if (model.pen_flow_percorso.capo_imputazione_legge == "" || model.pen_flow_percorso.assoluzione == ""|| (model.pen_flow_percorso.assoluzione != Model.lista_esito_del_processo[1] && model.pen_flow_percorso.assoluzione != Model.lista_esito_del_processo[0])
      || model.pen_get_percorso.distribuzione_delle_sanzioni.length< 1) {
        canShow += " not-visible";
      }
      break;
    case "finePercorso":
      if (model.pen_flow_percorso.capo_imputazione_legge == "" || model.pen_flow_percorso.assoluzione == "") {
        canShow += " not-visible";
      }
      break;
  }
  return canShow;
}

//MINMAX
const fromMinMaxSlider = (active: boolean, cid: string) => {
  changePercorsoAt(cid)
};
const minMaxSlider_importo_evaso2 = ref(null);
const updateMinMaxSliders = (doSet: boolean = false): void => {
  try {
    if (doSet) {
      //@ts-ignore
      minMaxSlider_importo_evaso2.value.updateMinMaxSlider(model.pen_flow_percorso.importo_evaso_da, model.pen_flow_percorso.importo_evaso_a, model.pen_flow_percorso.importo_evaso_active)
    } else {
      //@ts-ignore
      minMaxSlider_importo_evaso2.value.updateMinMaxSlider()
    }
  } catch (e) {
    //console.log("%%%%", e)
  }
}

function vaiDashboard(): void {
  gtagO({
    event: 'link dashboard', 
    posizione: 'bottom Percorso',
    percorso: 'penale'
  })
}

// DOCUMENTI
function apriDocumenti(): void {
  gtagO({
    event: 'elenco sentenze'
  })

  let docDiv: HTMLElement | null = document.getElementById("percorsoDocumenti");
  if (docDiv) docDiv.style.display = "block";
}

const paginazione_component = ref(null);
const paginazione_jump_component = ref(null);

function sintetizzaConAi(estremi: string, id_doc_master: number, docRigaIndex: number): void {
  gtagO({
    event: 'sintetizza AI',
    target: estremi
  })

  let model: Model = Model.getReactiveInstance();
  Comms.getInstance().openSintesi('penale-percorso', docRigaIndex, {
    id_doc_master: id_doc_master,
    username: model.user.profile.userId,
    crmid: model.user.profile.crmId
  });
}
function apriDettaglio(estremi: string = "", id_doc_master: number = -1, id_databanks: number = -1, id: string = ""): void {
  gtagO({
    event: 'apri dettaglio',
    target: estremi!="" ? estremi : id_doc_master,
    destinazione: model.abbonatoDejure ? 'dejure' : 'overlay'
  })

  let comms: Comms = Comms.getInstance();
  if (id_doc_master < 0) {
    if (!model.openingDejure) {
      let allIds: number[] = [];
      model.pen_get_percorso.sentenze_paginate.forEach((item: KeyValoreStrNum) => {
        if (item.estremi) {
          allIds.push(item.id_doc_master as number)
        }
      })
      if (model.abbonatoDejure) {
        model.openingDejure = true;
        comms.callDejure(allIds, ()=> { model.openingDejure = false});
      }
    }
  } else {
    if (model.abbonatoDejure) {
      comms.openDettaglioDejure(id_doc_master, id_databanks, id);
    } else {
      comms.openDettaglioModal(id_doc_master, id_databanks, id);
    }
  }
}
const updatePaginazione = (): void => {
  try {
    //@ts-ignore
    paginazione_component.value.updatePaginazione();
    //@ts-ignore
    if (paginazione_jump_component && paginazione_jump_component.value) paginazione_jump_component.value.updatePaginazione();
  } catch (e) {
    //console.log("%%%%", e)
  }
}

//REPORT
function generaReport(): void {
  let sFiltriAttivi = "";

  if (model.pen_flow_percorso.capo_imputazione_legge != "") {
    sFiltriAttivi = "Capo d'imputazione";
  }
  if (model.pen_flow_percorso.importo_evaso_active) {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Importo evaso";
  }
  if (model.pen_flow_percorso.assoluzione != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Assoluzione";
  }
  if (model.pen_flow_percorso.assoluzione_motivo != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Motivo assoluzione";
  }
  if (model.pen_flow_percorso.pena_principale != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Pena principale";
  }

  gtagO({
    event: 'genera report',
    filtriAttivi: sFiltriAttivi
  })

  PdfGenerator.pen_generatePdfPercorso("penale");
}

function isRebranding(): boolean {
  return frontendConfig.rebranding;
}
</script>

<template>
  <div class="container percorso percorso-page">

    <div :class="canShowField('capo_imputazione_legge')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Scegli il capo di imputazione da sottoporre all’analisi
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select js-choice" id="input_capo_imputazione_legge"
                v-model="model.pen_flow_percorso.capo_imputazione_legge"
                @change="changePercorsoAt('capo_imputazione_legge')"></select>
      </div>
    </div>

    <div :class="canShowField('importo_evaso')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Individua il valore o un intervallo di valori degli importi contestati
        <span class="not-visible" v-if="model.pen_get_percorso.importo_evaso.valore > 0" v-html="'&nbsp; (Mediano: ' + model.pen_get_percorso.importo_evaso.valore + ')'"></span>
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
          <div class="slider-cont percorso">
            <MinMaxSlider  ref="minMaxSlider_importo_evaso2"
                v-model:active="model.pen_flow_percorso.importo_evaso_active"
                v-model:min="model.pen_flow_percorso.importo_evaso_min"
                v-model:max="model.pen_flow_percorso.importo_evaso_max"
                :step="Model.lista_importi_minMax[2]"
                v-model:min-value="model.pen_flow_percorso.importo_evaso_da"
                v-model:max-value="model.pen_flow_percorso.importo_evaso_a"
                :cid="'importo_evaso2'"
                :changeFunct="fromMinMaxSlider"
            />
            <div class="legenda"><span v-html="model.pen_flow_percorso.importo_evaso_da"></span>
              &nbsp; <i class="bi bi-arrows"></i> &nbsp;
              <span v-html="model.pen_flow_percorso.importo_evaso_a"></span></div>
        </div>


      </div>
    </div>

    <div :class="canShowCanvas('esito_del_processo')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
            <div class="col-4 p-2">
            <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_esito_del_processo" data-bs-title="Questo grafico ti permette di scegliere tra le sentenze in cui tutti gli imputati sono stati
              assolti oppure tra quelle in cui tutti gli imputati sono stati condannati.<br> Le sentenze miste presentano imputati in parte assolti e in parte condannati, oppure più capi di imputazioni per cui un imputato è stato in parte assolto e in parte condannato.<br>">
              <i class="bi bi-info-circle-fill"></i>
            </button>
              <h6>Esito del giudizio</h6><br>
              <em>Numero sentenze prese in esame</em><br>
              {{ model.pen_get_percorso.totale_numero_sentenze.valore }}
            </div>
            <div class="col-8 canvasCont"><canvas id="canvas_assoluzione"></canvas></div>
        </div>
      </div>
    </div>

    <div :class="canShowField('assoluzione')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Specifica ora l’esito del giudizio da analizzare tra assoluzione, condanna o ipotesi mista di condanna e assoluzione
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_assoluzione" v-model="model.pen_flow_percorso.assoluzione"
                @change="changePercorsoAt('assoluzione')">
          <option value="">Scegli...</option>
          <template v-if="model.pen_get_percorso.esito_del_processo && model.pen_get_percorso.esito_del_processo.length > 0">
          <option v-for="item in model.pen_get_percorso.esito_del_processo" :value="item.assoluzione" :key="'esito_'+item.assoluzione">{{ Model.lista_esito_del_processo_labels[Model.lista_esito_del_processo.indexOf(item.assoluzione as string)] }}</option>
          </template>
          <template v-else>
            <option v-for="(item, index) in Model.lista_esito_del_processo" :value="item" :key="'esito_'+item">{{ Model.lista_esito_del_processo_labels[index] }}</option>
          </template>
        </select>
      </div>
    </div>

    <div :class="canShowCanvas('distribuzione_motivi_assoluzione')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra ">
        <div class="row">
          <div class="col-4 p-2">
            <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                    id="tooltip_distribuzione_motivi_assoluzione"
                    data-bs-title="Questo grafico ti permette di scegliere tra le diverse tipologie di motivazioni che hanno portato all’assoluzione dell’imputato ed è attivo sulle sole sentenze in cui vi è stata almeno una assoluzione.<br>
Scegli il filtro di tuo interesse.
">
              <i class="bi bi-info-circle-fill"></i>
            </button>
            <h6>Distribuzione motivi assoluzione</h6> <br><em>Numero sentenze prese in esame</em><br>
            {{ model.pen_get_percorso.totale_numero_sentenze.valore }}</div>
          <div class="col-8 canvasCont"><canvas id="canvas_distribuzione_motivi_assoluzione"></canvas></div>
        </div>
      </div>
    </div>

    <div :class="canShowField('assoluzione_motivo')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Scegli ora i motivi che hanno portato all’assoluzione
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select js-choice" id="input_assoluzione_motivo" v-model="model.pen_flow_percorso.assoluzione_motivo"
                @change="changePercorsoAt('assoluzione_motivo')">
          <option value="">Scegli...</option>
            <option v-for="item in model.pen_get_percorso.distribuzione_motivi_assoluzione" :value="item.assoluzione_motivo" :key="'motivo_'+item.assoluzione_motivo">{{ item.assoluzione_motivo }}</option>
        </select>
      </div>
    </div>

    <div :class="canShowCanvas('distribuzione_delle_sanzioni')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra ">
        <div class="row">
          <div class="col-4 p-2">
            <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                    id="tooltip_distribuzione_delle_sanzioni"
                    data-bs-title="Questo grafico ti permette di scegliere tra le diverse tipologie di pena principale previste dal nostro ordinamento e si applica alle sole sentenze in cui vi è stata almeno una condanna.<br>
Scegli il filtro di tuo interesse.
">
              <i class="bi bi-info-circle-fill"></i>
            </button><h6>Distribuzione delle sanzioni</h6> <br><em>Numero sentenze prese in esame</em><br>
            {{ model.pen_get_percorso.totale_numero_sentenze.valore }}
          </div>
          <div class="col-8 canvasCont"><canvas id="canvas_distribuzione_delle_sanzioni"></canvas></div>
        </div>
      </div>
    </div>

    <div :class="canShowField('pena_principale')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Scegli ora tra le tipologie di sanzioni applicabili
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select js-choice" id="input_pena_principale" v-model="model.pen_flow_percorso.pena_principale"
                @change="changePercorsoAt('pena_principale')">
          <option value="">Scegli...</option>
          <option v-for="item in model.pen_get_percorso.distribuzione_delle_sanzioni" :value="item.pena_principale" :key="'pena_'+item.pena_principale">{{ item.pena_principale }}</option>
        </select>
      </div>
    </div>

    <div :class="canShowField('finePercorso')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Hai completato il percorso di analisi guidato sulle sentenze <span v-if="model.pen_flow_percorso.assoluzione !=''">di <em>{{model.pen_flow_percorso.assoluzione}}</em></span>
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0 finepercorso">
        <div class="mb-2">Ora puoi scegliere tra due opzioni:<br>
          &bull; Genera l’elenco delle sentenze corrispondenti alle tue scelte.<br>
          &bull; Accedi alla dashboard per ulteriori analisi.<br>
          &nbsp; Qui potrai consultare i dati in base a vari criteri come il tribunale, il giudice, la durata del processo, e l'esito per città.<br>

          <button class="btn btn-lg btn-error my-3" @click="apriDocumenti()">
            <i class="bi bi-file-earmark"></i> &nbsp; Elenco Sentenze
          </button>
          <RouterLink to="/penale/dashboard" class="btn btn-lg btn-error my-3" @click="vaiDashboard()">
            <i class="bi bi-graph-up"></i> &nbsp; Vai alla Dashboard
          </RouterLink>
        </div>

        <div id="percorsoDocumenti" class="pt-3" style="display: none">
          <h4>Elenco sentenze</h4>

          <div class="table-responsive small table-documenti"  v-if="model.pen_get_percorso.sentenze_paginate && model.pen_get_percorso.sentenze_paginate.length && model.pen_get_percorso.sentenze_paginate.length > 0">
            <table class="table table-striped table-sm">
              <!-- thead>
              <tr>
                <th scope="col">Estremi</th>
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
              </thead -->
              <tbody>
              <template v-for="(item, index) in model.pen_get_percorso.sentenze_paginate">
                <tr v-if="item.estremi" :id="'docRiga-penale-percorso-'+index">
                  <!-- td><em>{{ (new Date(item.date)).toLocaleDateString() }}</em></td -->
                  <td>{{item.estremi}}</td>
                  <td class="text-right">
                    <a href="javascript:void(0)" @click="sintetizzaConAi(item.estremi as string, item.id_doc_master as number, index)" v-if="item.tipologia_doc != 136">
                      <i class="bi bi-stars"></i> Sintetizza con AI
                    </a>
                    <span v-else> </span>
                  </td>
                  <td class="text-right">
                    <a href="javascript:void(0)" @click="apriDettaglio(item.estremi as string, item.id_doc_master as number, item.id_databanks as number, item.id as string)">
                      <i class="bi bi-link"></i> Apri dettaglio
                    </a>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>

          <div class="row"  v-if="model.pen_get_percorso.sentenze_paginate && model.pen_get_percorso.sentenze_paginate.length && model.pen_get_percorso.sentenze_paginate.length > 0">

            <div class="col-12 col-sm-6 col-xl-4 paginazione-azione">
              <button class="btn btn-sm btn-primary" @click="apriDettaglio()" v-if="model.abbonatoDejure"><i class="bi bi-box-arrow-up-right" v-if="!model.openingDejure"></i> <div v-else class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>&nbsp;  Approfondisci su DeJure</button>
              <button class="btn btn-sm btn-error" @click="generaReport()" v-if="model.pen_flow_percorso.assoluzione != ''">
                <i class="bi bi-download" v-if="!model.generatingPdf"></i> 
                <div v-else class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                &nbsp; Genera report
              </button>
            </div>

            <div class="col-12 col-sm-6 col-xl-3 paginazione-label">
              <b>{{ model.pen_flow_percorso.paginazione_tot }}</b> Elementi Totali |
              Pagina <b>{{ (model.pen_flow_percorso.paginazione_start + 1) }}</b> di
              <b>{{ (model.pen_flow_percorso.paginazione_pages + 1) }}</b>
            </div>
            <div class="col-12 col-sm-12 col-xl-5">
              <PaginazionePercorso ref="paginazione_component" @recalc="callQueryPaginazione()"></PaginazionePercorso>
            </div>


            <!-- principi di diritto -->
            <div class="col-12 mt-4" v-if="model.abbonatoDejure && model.pen_get_percorso.sentenze_paginate_jump_display && model.pen_get_percorso.sentenze_paginate_jump_display.length && model.pen_get_percorso.sentenze_paginate_jump_display.length > 0">
              <h4>Principi di diritto</h4>
              <div class="table-responsive small table-documenti">
                <table class="table table-striped table-sm">
                  <tbody>
                  <template v-for="(item, index) in model.pen_get_percorso.sentenze_paginate_jump_display">
                    <tr v-if="item.estremi || item.id_doc_master" :id="'docRiga-penale-percorso-jump-'+index">
                      <td v-if="item.estremi">{{item.estremi}}</td>
                      <td v-else> {{item.id_doc_master}}</td>
                      <td class="text-right">
                        <a href="javascript:void(0)" @click="apriDettaglio(item.estremi as string, item.id_doc_master as number, item.id_databanks as number, item.id as string)">
                          <i class="bi bi-link"></i> Apri dettaglio
                        </a>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 col-xl-4 paginazione-azione">

                </div>
                <div class="col-12 col-sm-6 col-xl-3 paginazione-label">
                  <b>{{ model.pen_flow_percorso.diritto_paginazione_tot }}</b> Elementi Totali |
                  Pagina <b>{{ (model.pen_flow_percorso.diritto_paginazione_start + 1) }}</b> di
                  <b>{{ (model.pen_flow_percorso.diritto_paginazione_pages + 1) }}</b>
                </div>
                <div class="col-12 col-sm-12 col-xl-5">
                  <PaginazionePercorsoJump ref="paginazione_jump_component"></PaginazionePercorsoJump>
                </div>
              </div>


            </div>

          </div>
          <div class="row" v-else>
            <div class="col-12">
              Non sono presenti sentenze
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>

</template>